import React, { useState, useEffect } from "react";
// import { API } from "aws-amplify";
import { Button, withStyles } from "@material-ui/core";
import AccountMenu from "./account-menu";
import LoginForm from "../../containers/LoginForm";
import Logo from "../../images/fansfirst-logo-smaller.svg";
import LogoFr from "../../images/fansfirst-logo-smaller-fr.svg";
import { useTranslation } from "react-i18next";
import {
  getSavedLang,
  saveLang,
  guessLangFromBrowser,
  getLangFromUrl,
  setLangInUrl,
} from "../../utils/lang";
import analytics from "../../analytics";

const styles = (theme) => ({
  navContainer: {
    position: "relative",
    boxShadow: "0 4px 6px 0 rgb(0 0 0 / 3%)",
    backgroundColor: "#fafafa",
    width: "100%",
    zIndex: theme.zIndex.drawer + 1,
  },
  navContainerMobile: {
    position: "relative",
    boxShadow: "0 4px 6px 0 rgb(0 0 0 / 3%)",
    backgroundColor: "#fafafa",
    width: "100%",
    zIndex: "999",
  },
  nav: {
    maxWidth: 1366,
    margin: "0 auto",
    display: "flex",
  },
  logoContainer: {
    position: "relative",
    padding: theme.spacing.unit * 2,
    flex: 1,
  },
  logo: {
    verticalAlign: "middle",
  },
  linksContainer: {
    display: "flex",
    padding: theme.spacing.unit * 2,
    flex: 1,
    verticalAlign: "middle",
  },
  linksContainerAuth: {
    display: "flex",
    padding: `9px ${theme.spacing.unit * 2}px`,
    flex: 1,
    verticalAlign: "middle",
  },
  navLinks: {
    flex: 1,
    minHeight: theme.spacing.unit * 5,
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: `${theme.spacing.unit * 4}px`,
  },
  accountLinksContainer: {
    minHeight: theme.spacing.unit * 5,
    borderRight: "1px solid #ddd",
  },
  sellButton: {
    height: "46px",
    minWidth: theme.spacing.unit * 12,
    margin: `0 ${theme.spacing.unit * 2}px`,
    backgroundColor: "#00de94",
    color: "#ffffff",
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "#00c281",
    },
    textTransform: "none",
    textAlign: "center",
  },
  sellButtonAuth: {
    height: "46px",
    minWidth: theme.spacing.unit * 12,
    margin: `8px ${theme.spacing.unit * 2}px`,
    backgroundColor: "#00de94",
    color: "#ffffff",
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "#00c281",
    },
    textTransform: "none",
    textAlign: "center",
  },
  registerButton: {
    height: "46px",
    margin: `0 ${theme.spacing.unit}px`,
    color: "#000000",
    textTransform: "none",
    textAlign: "center",
  },
  loginButton: {
    height: "46px",
    margin: `0 ${theme.spacing.unit}`,
    backgroundColor: "#00a0ff",
    color: "white",
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "#0098f3",
    },
    textTransform: "none",
    textAlign: "center",
  },
  [theme.breakpoints.down("md")]: {
    button: {
      margin: `0`,
    },
  },
  langToggle: {
    display: "inline-flex",
    border: "1px solid #BDBDBD",
    borderRadius: 999,
    overflow: "hidden",
    height: 32,
    minWidth: "fit-content",
    maxWidth: "75px",
    background: "#fff",
    flexShrink: 0,
    fontSize: "11px",
    marginRight: theme.spacing.unit * 2,
    alignSelf: "center",
  },
  langBtn: {
    padding: "0 6px",
    fontWeight: 700,
    lineHeight: "30px",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    color: "#000",
    flex: "0 1 auto",
    textAlign: "center",
    whiteSpace: "nowrap",
    fontSize: "11px",
    minWidth: "auto",
  },
  langBtnActive: { 
    background: "#2196F3", 
    color: "#fff", 
    fontWeight: 800 
  },
});
const renderSellBtn = ({ classes, isAuthenticated, sellLabel }) => {
  return (
    <Button
      className={
        isAuthenticated
          ? classes.sellButtonAuth
          : classes.sellButton
      }
      href="/sell"
      variant="extendedFab"
      onClick={() => analytics.track("sell_clicked", {})}
    >
      {sellLabel}
    </Button>
  )
}
const renderRegisterBtn = ({ classes, signUpLabel }) => {
  return (
    <Button
      href="/signup"
      className={classes.registerButton}
      onClick={() => analytics.track("signup_clicked", {})}
    >
      {signUpLabel}
    </Button>
  );
};
const renderLoginBtn = ({ classes, handleLogin, loginLabel }) => {
  return (
    <Button 
      className={classes.loginButton} 
      onClick={handleLogin}
      variant="extendedFab"
    >
      {loginLabel}
    </Button>
  );
};

const desktopNav = ({ classes, isAuthenticated, currUser, handleLogout, ...props }) => {
  const [isLoginFormOpen, setIsLoginFormOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState(
    getLangFromUrl() || getSavedLang() || guessLangFromBrowser()
  );
  const hideLang = (() => {
    try {
      const p = window.location && window.location.pathname;
      // Hide on Ticket pages (both route shapes):
      // 1) /seats/:slug/:gameId/:seatId
      // 2) /games/:gameId/seats/:seatId
      const seatsPath = /^\/seats\/[^/]+\/[^/]+\/[^/]+$/;
      const gamesSeatsPath = /^\/games\/[^/]+\/seats\/[^/]+$/;
      const thankYouPath = /^\/thankyou(\/|$)/;
      return seatsPath.test(p) || gamesSeatsPath.test(p) || thankYouPath.test(p);
    } catch (_) { return false; }
  })();
  useEffect(() => {
    const curr = (i18n && i18n.language) || "";
    const norm = curr.startsWith("fr") ? "fr" : curr.startsWith("en") ? "en" : curr;
    if (norm && norm !== lang) setLang(norm);
  }, [i18n && i18n.language]);
  const logoSrc = lang === "fr" ? LogoFr : Logo;

  // const persistPreferredLang = (l) => {
  //   try {
  //     if (!isAuthenticated || !currUser || !currUser.email) return;
  //     const email = String(currUser.email || "").toLowerCase();
  //     API.post("v2", "marketplace/users/update-preferred-lang", {
  //       body: {
  //         email,
  //         preferredLang: l,
  //       },
  //     }).catch(() => {});
  //   } catch (_) {}
  // };
  const persistPreferredLang = () => {};

  const chooseLang = (l) => {
    const curr = (i18n && i18n.language) || "";
    if (curr === l || curr.startsWith(l)) return;
    setLang(l);
    saveLang(l);
    if (getLangFromUrl() !== l) setLangInUrl(l);
    i18n.changeLanguage(l);
    persistPreferredLang(l);
    analytics.track("language_selected", { language: l });
  };
  const handleLogin = () => {
    analytics.track("login_opened", {});
    setIsLoginFormOpen(true);
  };

  const handleCloseLoginForm = () => {
    setIsLoginFormOpen(false);
  };
  
  return (
    <div
      className={
        window.screen.width < 962
          ? classes.navContainerMobile
          : classes.navContainer
      }
    >
      <nav className={classes.nav} position="relative">
        <div className={classes.logoContainer}>
          <a href="/">
            <img
              src={logoSrc}
              alt="FansFirst Logo"
              className={classes.logo}
            />
          </a>
        </div>
        <div className={classes.linksContainer}>
          <div className={classes.navLinks}>
            {!hideLang && (
              <div className={classes.langToggle} aria-label="Language switcher">
                <button
                  className={`${classes.langBtn} ${lang === "fr" ? classes.langBtnActive : ""}`}
                  onClick={() => chooseLang("fr")}
                  type="button"
                >
                  {t("common.lang_fr")}
                </button>
                <button
                  className={`${classes.langBtn} ${lang === "en" ? classes.langBtnActive : ""}`}
                  onClick={() => chooseLang("en")}
                  type="button"
                >
                  {t("common.lang_en")}
                </button>
              </div>
            )}
            {isAuthenticated && currUser ? "" : renderSellBtn({ classes, isAuthenticated, sellLabel: t('common.sell_tickets') })}
            <div className={classes.accountLinksContainer} />
            {isAuthenticated && currUser ? (
              <AccountMenu currUser={currUser} handleLogout={handleLogout} />
            ) : (
              <React.Fragment>
                {renderRegisterBtn({ classes, signUpLabel: t('common.sign_up') })}
                {renderLoginBtn({ classes, handleLogin, loginLabel: t('common.log_in') })}
                {isLoginFormOpen && (
                  <LoginForm
                    isAuthenticated={isAuthenticated}
                    currUser={currUser}
                    handleLogout={handleLogout}
                    {...props}
                    isOpen={isLoginFormOpen}
                    handleClose={handleCloseLoginForm}
                  />
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default withStyles(styles)(desktopNav);
